export function getRuleAsInteger(rule: string): number {
  switch (rule) {
    case 'one-active':
      return 1
    case 'two-active':
      return 2
    case 'three-active':
      return 3
    case 'four-active':
      return 4
    case 'five-active':
      return 5
    default:
      return 1
  }
}
export function getBookingGranularityHours(bookingGranularity: string): number {
  switch (bookingGranularity) {
    case '1hr':
      return 1
    case '2hr':
      return 2
    case '3hr':
      return 3
    case '4hr':
      return 4
    case '5hr':
      return 5
    case '6hr':
      return 6
    case '7hr':
      return 7
    case '8hr':
      return 8
    default:
      return 1
  }
}
